import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import _ from 'lodash';
import Dialog from '../../../common/Dialog';

const DialogModel = ({
  setModal,
  isModelOpen,
  title,
  description,
  handleDeleteSuccess,
  deleteButtonText = 'Delete'
}) => {
  const focusButtonRef = useRef();

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = '';
    };
  });

  useEffect(() => {
    isModelOpen && focusButtonRef.current.focus();
  }, [isModelOpen]);

  const setFocusToButton = event => {
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (relatedClassName.includes('dialogComponent')) {
        return;
      } else {
        focusButtonRef.current.focus();
      }
    }
  };

  return (
    <div className="mainModal dialogModel">
      <div className="transparentBg" onClick={() => setModal(false)}></div>
      <Dialog
        className="modalContent"
        onBlur={setFocusToButton}
        escKeyFunction={() => setModal(false)}
      >
        <div className="modalSection">
          <div className="topHeader">
            <h1 id="dialogTitleHeading" className="modalHeading">
              {title}
            </h1>
          </div>
          <p className="textCenter">{description}</p>

          <div className="">
            <button
              ref={focusButtonRef}
              className="pinkBorderButton dialogComponent themeFocus"
              onClick={() => setModal(false)}
            >
              Cancel
            </button>
            <button
              onClick={() => handleDeleteSuccess()}
              className="pink dialogComponent themeFocus gradientPink"
            >
              {deleteButtonText}
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
DialogModel.propTypes = {
  setModal: PropTypes.func,
  isModelOpen: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string
};

DialogModel.defaultProps = {
  setModal: () => {},
  title: '',
  isModelOpen: false,
  description: ''
};

export default DialogModel;
